/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import StyledPageMenuIcon from "../../Layout/PageMenu/PageMenuIcon";
import AuditLogPopover from "./AuditLogPopover";

export default function () {
  const anchor = React.useRef<HTMLElement>(null);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    setShow(false);
  }, []);

  return (
    <>
      <span
        ref={anchor}
        style={{
          fontSize: "18px",
          lineHeight: "normal",
          cursor: "pointer",
          verticalAlign: "0.2em",
        }}
      >
        <StyledPageMenuIcon
          icon={faCircleInfo}
          onClick={() => setShow(!show)}
        />
      </span>
      <AuditLogPopover show={show} anchor={anchor} />
    </>
  );
}
